import { Hidden } from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';
import React from 'react';
import { buttonStyles } from '../../../../global/constants/theme/styles/components/buttonstyles';
import { ListItem } from '../../../../search/search-model';
import { SearchProps } from '../../models/arc-epi-props';
import { DioceseInstitutionItem } from '../institutions/institution-model';

interface DioceseInstitutionItemProps {
    item: ListItem,
    action: () => void,
    settings: SearchProps,
}

export function DioceseInstitutionItemView(props: DioceseInstitutionItemProps){

    const casted = props.item as DioceseInstitutionItem;
    const buttonClasses = buttonStyles();

    function RenderRemovalRequestPending(){
        if (!casted.is_removed) return null;

        return (<>
                <Hidden smUp>
                <p><strong>{props.settings?.institutionStatusLabel}</strong></p>
                </Hidden>
                <div className='sort-table-row-cell-status'>
                    <WarningIcon className='sort-table-row-cell-status-icon warning ' />
                    <p>
                        { props.settings?.removalRequestPendingText || 'Removal Request Pending' }
                    </p>
                </div>
            </>);
    }

    return (
        <div className='sort-table-row'>
            <div className='sort-table-row-cell'>
                <Hidden smUp>
                    <p className='input-label'>{props.settings?.institutionIdLabel}</p>
                </Hidden>
                <p>
                    <button className={buttonClasses.linkButton} type='button' onClick={props.action}>
                        {casted?.client_number}
                    </button>

                </p>
            </div>
            <div className='sort-table-row-cell'>
                <Hidden smUp>
                    <p className='input-label'>{props.settings?.institutionNameLabel}</p>
                </Hidden>
                <p>
                    {casted?.organization_name}
                </p>
            </div>

            <div className='sort-table-row-cell'>
                <Hidden smUp>
                    <p className='input-label'>{props.settings?.institutionCityLabel}</p>
                </Hidden>
                <p>
                    {casted?.city}
                </p>
            </div>
            <div className='sort-table-row-cell'>
                <RenderRemovalRequestPending/>
            </div>
        </div>);
}